import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next";
import { ResponsiveContainer, LineChart, ReferenceArea, CartesianGrid, XAxis, YAxis, Legend, ReferenceDot, ReferenceLine, Line, Tooltip } from "recharts"


export const HrHistoryGraph = ({
    hrData,
    hrThresholds,
    date,
    onDateChange = (e) => { }
}) => {

    const [t] = useTranslation(["global", "health"]);

    // Funzioni per ottenere inizio e fine della giornata
    const getStartOfDay = () => Math.floor(date.setHours(0, 0, 0, 0));
    const getEndOfDay = () => Math.floor(date.setHours(23, 59, 59, 999));


    // Calcola BPM massimo e minimo
    const maxBpmEntry = hrData?.length ? hrData.reduce((max, d) => (d.hr > max.hr ? d : max), hrData[0]) : null;
    const minBpmEntry = hrData?.length ? hrData.reduce((min, d) => (d.hr < min.hr ? d : min), hrData[0]) : null;

    const maxBpm = maxBpmEntry?.hr ?? "--";
    const minBpm = minBpmEntry?.hr ?? "--";
    const maxBpmTime = maxBpmEntry ? new Date(maxBpmEntry.timestamp * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }) : "--:--";
    const minBpmTime = minBpmEntry ? new Date(minBpmEntry.timestamp * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }) : "--:--";

    const isMaxBpmOver = maxBpmEntry?.hr > hrThresholds[1]
    const isMinBpmUnder = minBpmEntry?.hr < hrThresholds[0]

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip bg-dark card">
                    <div className="card-header"><b>{payload[0].value}</b> bpm</div>
                    <div className="card-footer"> {new Date(label * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</div>

                </div>
            );
        }

        return null;
    };


    return <div className="card mt-2 bg-black bg-opacity-10 text-white p-4">

        {/* BPM Massimo e Minimo */}
        <div className="d-flex  justify-content-between mb-3">
            <div>
                <h4><i className="fa-solid fa-heart-pulse text-muted"></i> {t("health:entity.data.heart_rate")}</h4>
                <span className="small text-muted">{hrData.length} {t("health:unit.measurements", { count: hrData.length })}</span>
            </div>

            <div>
                <strong>Max</strong> <span className="h4" style={{ color: isMaxBpmOver ? "#cd3342" : "white" }}>{maxBpm} </span><small> bpm </small><span className="text-muted ms-2">{t("particles.to_time")} {maxBpmTime}</span><br />
                <strong>Min</strong> <span className="h4" style={{ color: isMinBpmUnder ? "#cd3342" : "white" }}>{minBpm} </span><small> bpm </small> <span className="text-muted ms-2">{t("particles.to_time")} {minBpmTime}</span>
            </div>
            <div>
                <Calendar value={date} onChange={(e) => onDateChange(e.value)} dateFormat="dd/mm/yy" />
            </div>

        </div>

        {/* Grafico */}
        {
            hrData?.length > 0 ?
                <ResponsiveContainer width="100%" height={500}>
                    <LineChart data={hrData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                        <ReferenceArea y1={hrThresholds[0]} y2={hrThresholds[1]} fill="#198754" opacity={0.3} />
                        <CartesianGrid strokeDasharray="3 3" opacity={0.5} />
                        <XAxis
                            dataKey="timestamp"

                            type="number"
                            domain={[getStartOfDay() / 1000, getEndOfDay() / 1000]}
                            tickFormatter={(tick) =>
                                new Date(tick * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })
                            }
                            ticks={[(getStartOfDay() / 1000, getStartOfDay() / 1000) + 21600, (+getStartOfDay() / 1000) + 43200, (+getStartOfDay() / 1000) + 64800, getEndOfDay() / 1000]}
                            scale="time"
                        />
                        <YAxis dataKey="hr"
                            type="number"
                            scale="linear"
                            domain={[20, 140]}
                        />
                        <Tooltip content={CustomTooltip} />
                        <Legend />
                        {
                            hrData?.length > 10 &&
                            <>
                                <ReferenceDot y={minBpmEntry.hr} x={minBpmEntry.timestamp} fill={isMinBpmUnder ? "#cd3342" : "white"} opacity={0.5} />
                                <ReferenceDot y={maxBpmEntry.hr} x={maxBpmEntry.timestamp} fill={isMaxBpmOver ? "#cd3342" : "white"} opacity={0.5} />
                                <ReferenceLine label="Min" y={minBpmEntry.hr} stroke={isMinBpmUnder ? "#cd3342" : "yellow"} opacity={0.5} />
                                <ReferenceLine label="Max" y={maxBpmEntry.hr} stroke={isMaxBpmOver ? "#cd3342" : "yellow"} opacity={0.5} />
                            </>
                        }


                        <Line type="monotone" dataKey="hr" name="bpm" stroke="#ff4d4d" dot={false} strokeWidth={2} />
                    </LineChart>
                </ResponsiveContainer>
                : <h3 className="text-muted">{t("health:helper.no_data")}</h3>
        }

    </div>



}

